import React, { FC, useCallback } from "react";
import moment from "moment";
import Page from "../common/navigation/Page";
import Spinner from "../common/F7/Spinner";
import ListBlock from "../common/F7/ListBlock";
import InlineSpinner from "../common/F7/InlineSpinner";
import Card from "../common/F7/Card";
import ListBlockMediaItem from "../common/F7/ListBlockMediaItem";
import BackButton from "../common/navigation/BackButton";
import { useDatabaseStatus } from "../../hooks/database/useDatabaseStatus";
import { useListProjects } from "../../hooks/database/usePouchList";

const SyncPage: FC = () => {
  const { syncingInventories, dirty, dirtyInventories, lastSync, lastSyncInventories, loadedInventories, syncError, sync } =
    useDatabaseStatus();
  const { data: projects } = useListProjects();

  const handleSyncClick = useCallback((inventoryId: string) => sync([inventoryId]), [sync]);

  if (!projects) {
    return <Spinner />;
  }

  return (
    <Page navbarLeft={<BackButton />} title="Sync">
      <div>Last sync: {lastSync ? moment(lastSync).fromNow() : "never"}</div>
      {dirty || dirtyInventories.length > 0 ? <div>Has local changes</div> : null}
      {syncError ? (
        <div
          style={{
            color: "red",
            whiteSpace: "initial",
          }}
        >
          Sync failed
        </div>
      ) : null}
      {projects.map((project) => (
        <Card header={project.name} key={project._id}>
          <ListBlock style={{ marginTop: 0 }}>
            {Object.entries(project.inventories || {}).map(([key, inventory]) => (
              <ListBlockMediaItem
                key={key}
                style={loadedInventories.includes(key) ? {} : { color: "#aaa" }}
                onClick={() => handleSyncClick(key)}
                media={
                  syncingInventories.includes(key) ? (
                    <InlineSpinner />
                  ) : loadedInventories.includes(key) ? (
                    <i
                      className="fa fa-retweet"
                      onClick={() => handleSyncClick(key)}
                      style={{
                        fontSize: 30,
                        padding: 10,
                        margin: -10,
                      }}
                    />
                  ) : null
                }
                title={inventory.name}
                subtitle={
                  <span>
                    {key in lastSyncInventories ? <span>Synced {moment(lastSyncInventories[key]).fromNow()}</span> : null}
                    {key in lastSyncInventories && dirtyInventories.includes(key) ? <span>&nbsp;&mdash;&nbsp;</span> : null}
                    {dirtyInventories.includes(key) ? <span>Has local changes</span> : null}
                  </span>
                }
              />
            ))}
          </ListBlock>
        </Card>
      ))}
    </Page>
  );
};

export default SyncPage;
